module.exports = __webpack_public_path__ + "static/media/location.6eec19bc.svg";